// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.chart-container[data-v-484b0a8d] {\r\n  position: relative;\r\n  width: 100%;\r\n  height: calc(100vh - 84px);\n}\r\n", ""]);
// Exports
module.exports = exports;
